import React from 'react';
import ErrorReporter from 'app/components/ErrorReporter';
import { ApolloError } from 'apollo-client';
import CoachingConstants from 'coaching/CoachingConstants';

export default function CoachingErrorReporter({ error }: { error: ApolloError | string }) {
  return (
    <ErrorReporter error={error}>
      There was a problem loading this page. Please try again and contact{' '}
      {CoachingConstants.COACHING_HELP_EMAIL} if the problem persists.
    </ErrorReporter>
  );
}
